// Fills <cart-smart-upsell> with a product recommended for the item added to the cart last.
// The card HTML comes from sections/cart-upsell.liquid (Shopify product recommendations).
if (!customElements.get('cart-smart-upsell')) {
  customElements.define(
    'cart-smart-upsell',
    class CartSmartUpsell extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url) return;
        fetch(url)
          .then((response) => (response.ok ? response.text() : ''))
          .then((text) => {
            if (!text.trim()) return;
            const card = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-smart-upsell-card]');
            if (card && this.isConnected) this.innerHTML = card.innerHTML;
          })
          .catch(() => {});
      }
    }
  );
}
